/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-07-27 18:04:28
 * @LastEditors: linxi
 * @LastEditTime: 2023-08-03 17:10:25
 */
import React, { useContext, useEffect, useState } from 'react'
import { EditableList } from '../../compnents/list/EditableList'
import { NavBar } from '../../compnents/nav/NavBar'
import styles from './priceSetPage.module.css'
import { Columns } from './columns'
import {
  Button,
  Form,
  Row,
  Select,
  Space,
  Cascader as Cascaded,
  Input,
  notification,
} from 'antd'
import { CaretDownFilled, SearchOutlined } from '@ant-design/icons'
import { ThemeContext } from '../../theme/ThemeContext'
import { getAllList, getLabelList } from '../tenant/tenantSlice'
import { unwrapResult } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../app/store'
import { traceRoute } from '../../layouts/layoutSlice'
import { PriceSetModal } from './priceSetModal'
import { stringTrim } from '../../utils/StringUtils'
import { getPriceList, getPriceSet } from './priceSetPageSclice'
import { getVersionPageAsync } from '../versionManagement/versionManagementSlice'

const { Option } = Select
export const PriceSetPage = () => {
  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const theme = useContext(ThemeContext)

  const [params, setParams] = useState<any>({
    current: 0,
    size: 10,
  })

  const [page, setPage] = useState<any>({
    total: 0,
    items: [],
  })

  const [pageLoading, setPageLoading] = useState(false)

  const [allList, setAllList] = useState<any[]>() //省市数据

  const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]) //表格选中行

  const [selectedRow, setSelectedRow] = useState<any[]>([]) //表格选中行

  const [versionList, setVersionList] = useState<any>([])

  const [priceSetModalVisible, setPriceSetModalVisible] = useState(false) //批量修改价格模态框

  const [id, setId] = useState<any>()

  const [labelList, setLabelList] = useState<any>([]) //标签数据
  
  useEffect(() => {
    form.submit()
  }, [])

  const labelData = () => {
    dispatch(
      getLabelList({
        current: 1,
        size: 1000,
      })
    )
      .then(unwrapResult)
      .then((res) => setLabelList(res.records))
  }

  const refresh = () => {
    setParams({
      ...params,
      ...form.getFieldsValue(),
      labelIdSet: form.getFieldsValue()?.labelIdSet?.join(',') || undefined,
      current: 1,
    })
  }
  

  const getPageList = () => {
    //获取列表
    setPageLoading(true)
    dispatch(
      getPriceList({
        ...params,
        area: undefined,
        provinceCode: params?.area?.slice(0, 1)[0],
        cityCode: params?.area?.slice(1, 2)[0],
        countyCode: params?.area?.slice(2, 3)[0],
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        setPage({
          total: res.total,
          items: res.records,
        })
      })
      .finally(() => setPageLoading(false))
  }

  const loadData = (selectedOptions: any) => {
    const targetOption = selectedOptions[selectedOptions.length - 1]
    targetOption.loading = true
  }

  const rowSelection = {
    selectedRowKeys: selectedRowKeys,
    onSelectAll: (selected: any, selectedRows: any, changeRows: any) => {
      console.log(changeRows)

      let data: any = []
      if (selected) {
        data = [...changeRows.map((v: any) => v.tenantId), ...selectedRowKeys]
      } else {
        data = selectedRowKeys.filter(
          (item: any) => !changeRows.some((ele: any) => ele.tenantId === item)
        )
      }
      setSelectedRowKeys(data)
    },
    onSelect: (record: any, selected: any, selectedRows: any) => {
      let data: any = []
      if (selected) {
        data = [record?.tenantId, ...selectedRowKeys]
      } else {
        data = selectedRowKeys?.filter((v: any) => v != record?.tenantId)
      }
      setSelectedRowKeys(data)
    },
  }

  useEffect(() => {
    dispatch(getVersionPageAsync())
      .then(unwrapResult)
      .then((v) => {
        setVersionList(v)
      })
  }, [])

  useEffect(() => {
    //获取省市
    dispatch(getAllList())
      .then(unwrapResult)
      .then((t: any) => {
        setAllList(t)
      })
    labelData()
  }, [])

  useEffect(() => {
    if (params.current != 0) {
      getPageList()
    }
  }, [params])
  return (
    <>
      <NavBar
        style={{ margin: '10px 20px 0' }}
        where={['订单管理', '续订价格设置']}
        backtrace={{
          name: '订单管理',
          path: '/admin/tenant',
          state: {
            station: '1',
          },
        }}
      />

      <div className={styles.wrap}>
        {/* 筛选查询区域 */}
        <Form
          form={form}
          autoComplete='off'
          onFinish={(values) => {
            setParams({
              ...params,
              ...values,
              createStartTime: values.endTimeHead,
              createEndTime: values.endTimeTail,
              endTimeHead: undefined,
              endTimeTail: undefined,
              current: 1,
            })
          }}
        >
          <Row
            justify='space-between'
            align='middle'
            className={styles.queryWrap}
          >
            <Space>
              <Form.Item
                name='tenantName'
                noStyle
                getValueFromEvent={stringTrim}
              >
                <Input
                  allowClear
                  placeholder='机构名称'
                  prefix={<SearchOutlined />}
                  style={{ width: '160px' }}
                  onChange={form.submit}
                />
              </Form.Item>
              <Form.Item name='area' noStyle>
                <Cascaded
                  loadData={loadData}
                  changeOnSelect
                  suffixIcon={<CaretDownFilled style={{ color: theme.tc3 }} />}
                  style={{ width: '160px' }}
                  options={allList}
                  onChange={form.submit}
                  placeholder='请选择省市区'
                />
              </Form.Item>
              <Form.Item name='labelIdSet' noStyle>
                <Select
                  mode='tags'
                  suffixIcon={<CaretDownFilled style={{ color: theme.tc3 }} />}
                  placeholder='标签-全部'
                  onChange={refresh}
                  allowClear
                  style={{ width: '180px' }}
                >
                  {labelList.map((c: any) => (
                    <Select.Option key={c.id} value={c.id}>
                      {c.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item name='versionId' noStyle>
                <Select
                  suffixIcon={<CaretDownFilled style={{ color: theme.tc3 }} />}
                  placeholder='版本名称'
                  onChange={form.submit}
                  style={{ width: '180px' }}
                  allowClear
                >
                  {versionList.map((v: any) => (
                    <Select.Option key={v?.id} value={v?.id}>
                      {v?.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item name='priceStatus' noStyle>
                <Select
                  placeholder='价格状态'
                  onChange={form.submit}
                  style={{ width: '180px' }}
                  allowClear
                  suffixIcon={<CaretDownFilled />}
                >
                  <Option value={0}>未设置</Option>
                  <Option value={1}>已设置</Option>
                </Select>
              </Form.Item>
              <Button type='primary' htmlType='submit'>
                查询
              </Button>
            </Space>

            {/* 按钮区域 */}
            <Space className={styles.btnWrap}>
              <Button
                type='primary'
                disabled={!selectedRowKeys.length}
                onClick={() => setPriceSetModalVisible(true)}
              >
                批量新增价格
              </Button>
            </Space>
          </Row>
        </Form>

        {/* 表格区域 */}
        <div className={styles.tableWrap}>
          <EditableList
            rowKey={(record: any) => record.tenantId}
            page={{
              current: params.current,
              size: params.size,
              total: page.total,
              items: page.items,
            }}
            loading={pageLoading}
            className={styles.table}
            columns={Columns((v: any, t: any) => {
              setSelectedRow([v])
              setPriceSetModalVisible(true)
              if (t == 'setting') {
                setId(v?.tenantId)
              }
            }, params.size * (params.current - 1))}
            onChangePage={(current: number, size?: number) =>
              setParams({
                ...params,
                current,
                size,
              })
            }
            rowSelection={rowSelection}
          />
        </div>
      </div>
      <PriceSetModal
        selectedRowKeys={selectedRowKeys}
        id={id}
        visible={priceSetModalVisible}
        selectedRow={selectedRow}
        onOk={() => {
          setPriceSetModalVisible(false)
          setId('')
          setSelectedRowKeys([])
          setSelectedRow([])
        }}
        onCancel={() => {
          setPriceSetModalVisible(false)
          setId('')
          setSelectedRowKeys([])
          setSelectedRow([])
        }}
      />
    </>
  )
}
